export default "__VITE_ASSET__C_cHRSV4__"